import { render, staticRenderFns } from "./err404.vue?vue&type=template&id=5d3f90c6&scoped=true&"
import script from "./err404.vue?vue&type=script&lang=js&"
export * from "./err404.vue?vue&type=script&lang=js&"
import style0 from "./err404.vue?vue&type=style&index=0&id=5d3f90c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3f90c6",
  null
  
)

export default component.exports